import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/icons/jb-search-clear-icon/jb-search-clear-icon.css.ts
var jb_search_clear_icon_css_default = i`:host{cursor:pointer}svg{fill:var(--fill-color, black);height:25px;width:25px}`;

export {
  jb_search_clear_icon_css_default
};
